import { inject, Provider } from '@angular/core';
import { STUDENT_RECORD_ROUTE, StudentRecordRouteResolver } from '@k12/app-components';
import { AdminStore } from '../stores/admin-store';

/** Absolute route to the admin student record page. */
export const STUDENT_RECORD_PATH = '/student';

/**
 * Resolves the Student ID link target for the shared roster. Returns null for a user without an
 * admin role, which makes the roster render plain text instead of a link.
 *
 * The role check is a second belt — the admin route tree is already gated by
 * appRoleGuard(['K12.Admin']) — and it is not an access control: the student record route is what
 * protects the record. Its job here is to keep the link consistent with the guard.
 */
export function studentRecordRouteFactory(): StudentRecordRouteResolver {
  const store = inject(AdminStore);
  return () => (store.isAdminUser() ? STUDENT_RECORD_PATH : null);
}

/**
 * Admin is the only app with a student record page, so it is the only app that provides this.
 * The schools app must not — see STUDENT_RECORD_ROUTE.
 */
export const studentRecordRouteProvider: Provider = {
  provide: STUDENT_RECORD_ROUTE,
  useFactory: studentRecordRouteFactory
};
